import React from 'react';
import { Divider, Flex, useBreakpointValue, VStack } from 'native-base';
import { ProgramFeed } from './ProgramFeed';
import { DietDisplay } from './DietDisplay';
import { PhaseDisplay } from './PhaseDisplay';
import { TimeCount } from './TimeCount';
import { ScoreChart } from '../AreaChart/ScoreChart';
import { useDashboardPageState } from '../../hooks/useDashboardPageState';
import { getUserPhase } from './utils';
import { FoodGuide } from './FoodGuide';
import { MessageDisplay } from './MessageDisplay';
import { SurveyDisplay } from './SurveyDisplay';
import { HealthCoachMindGutCard } from '../HealthCoachDashboard/HealthCoachMindGutCard';
import { CoachNotes } from '../HealthCoachDashboard/CoachNotes';
import { MeetingNotes } from '../HealthCoachDashboard/MeetingNotes';
import { PhaseFoods } from './PhaseFoods';

const style = {
  overviewRowBorderColor: '#E5E5E5',
  overviewRowBorderStyle: 'solid',
  overviewRowBorderWidth: 1,
};

const {
  overviewRowBorderColor,
  overviewRowBorderStyle,
  overviewRowBorderWidth,
} = style;

const rowBorderStyle = {
  borderLeftColor: overviewRowBorderColor,
  borderLeftStyle: overviewRowBorderStyle,
  borderLeftWidth: overviewRowBorderWidth,
};

const columnBorderStyle = {
  borderTopColor: overviewRowBorderColor,
  borderTopStyle: overviewRowBorderStyle,
  borderTopWidth: overviewRowBorderWidth,
};

export const OverviewPanel = ({
  inDrawer = false,
  onPhaseDetailsClick,
  onPhaseLinkClick,
  readonly = false,
}) => {
  const {
    state: {
      user: { current_phase },
    },
  } = useDashboardPageState();
  const currentPhase = getUserPhase(current_phase);

  const flexDir = useBreakpointValue({
    base: 'column',
    md: inDrawer ? 'column' : 'row',
  });

  const borderStyle = useBreakpointValue({
    base: columnBorderStyle,
    md: inDrawer ? columnBorderStyle : rowBorderStyle,
  });

  return (
    <>
      <Flex
        direction={flexDir}
        m={6}
        mb={0}
        borderBottomColor={overviewRowBorderColor}
        borderBottomStyle={overviewRowBorderStyle}
        borderBottomWidth={overviewRowBorderWidth}
      >
        {inDrawer && (
          <VStack pb={6} pt={2}>
            <HealthCoachMindGutCard />
          </VStack>
        )}

        <Flex direction="column" minW={'75%'}>
          <ProgramFeed onPhaseLinkClick={onPhaseLinkClick} />
        </Flex>

        {inDrawer && (
          <Flex direction={flexDir}>
            <Flex direction="column" flexBasis={'30%'}>
              <MessageDisplay />
            </Flex>
          </Flex>
        )}

        <Flex mb={6} direction="column" flex={1} {...borderStyle}>
          <Flex
            py={inDrawer ? 6 : 0}
            p={inDrawer ? 2 : 6}
            flex={1}
            borderBottomColor={overviewRowBorderColor}
            borderBottomStyle={overviewRowBorderStyle}
            borderBottomWidth={overviewRowBorderWidth}
          >
            <PhaseDisplay onPhaseDetailsClick={onPhaseDetailsClick} />
          </Flex>
          <Flex py={inDrawer ? 6 : 0} p={inDrawer ? 2 : 6} flex={1}>
            <TimeCount />
          </Flex>
        </Flex>
      </Flex>

      <Flex direction={flexDir} m={6} mb={0} mr={0}>
        <Flex
          direction="column"
          flexBasis={'30%'}
          mb={{ base: 8, md: inDrawer ? 8 : 0 }}
        >
          <DietDisplay readonly={readonly || !!inDrawer} />
        </Flex>

        <PhaseFoods inDrawer={inDrawer} />
      </Flex>

      {currentPhase >= 2 && (
        <Flex
          borderTopColor={overviewRowBorderColor}
          borderTopStyle={overviewRowBorderStyle}
          borderTopWidth={overviewRowBorderWidth}
          direction={flexDir}
          m={6}
          mb={0}
          pt={6}
        >
          <Flex direction="column" flex={1} alignItems={'flex-start'}>
            <FoodGuide />
          </Flex>
        </Flex>
      )}

      <Flex
        m={6}
        mb={0}
        borderTopColor={overviewRowBorderColor}
        borderTopStyle={overviewRowBorderStyle}
        borderTopWidth={overviewRowBorderWidth}
      >
        <ScoreChart />
      </Flex>

      {inDrawer && <SurveyDisplay />}

      {inDrawer && (
        <VStack m={6} mt={0}>
          <Divider mb={6} />
          <CoachNotes />
          <Divider mt={6} />
        </VStack>
      )}

      {inDrawer && (
        <VStack m={6} mt={0}>
          <MeetingNotes />
        </VStack>
      )}
    </>
  );
};
